import * as R from 'ramda'

import {
  SET_TICKET_SATISFACTION_GRAPH,
  SATISFACTION_RATINGS_LOADED,
  SATISFACTION_RATINGS_LOAD_FAILED,
  HAS_NO_SURVEY,
  SET_HOME_PAGE_ID,
  SET_HOME_PAGE_URL,
} from 'actions'

const initialState = {
  loaded: false,
  ticketSatisfaction: [],
  homePageUrl: '/dashboards/home/',
  homePageId: null,
}
export default (state = initialState, action) => {
  if (action.type === SET_TICKET_SATISFACTION_GRAPH) {
    return R.mergeDeepRight(state, {
      ticketSatisfaction: action.answers.map((answer) => answer.id),
    })
  }
  if (action.type === HAS_NO_SURVEY) {
    return R.merge(state, {
      loaded: true,
    })
  }
  if (action.type === SATISFACTION_RATINGS_LOADED) {
    return R.mergeDeepRight(state, {
      loaded: true,
    })
  }
  if (action.type === SATISFACTION_RATINGS_LOAD_FAILED) {
    return R.mergeDeepRight(state, {
      loaded: false,
    })
  }
  if (action.type === SET_HOME_PAGE_ID) {
    return R.mergeDeepRight(state, {
      homePageId: action.homePageId,
    })
  }
  if (action.type === SET_HOME_PAGE_URL) {
    return R.mergeDeepRight(state, {
      homePageUrl: action.homePageUrl,
    })
  }

  return state
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/pages/dashboard/index.js